import { useMemo } from "react";
import { Link } from "react-router-dom";

import { useDocumentTitle } from "@/hooks/use-document-title";
import { useCMWFeatureFlagsQuery } from "@/api/cmw-feature-flags";
import { Button } from "@/_v2/components/ui/button";

import { buildDashboardMetrics, buildFlagInsights } from "./lib";
import {
  InsightStatCards,
  StatusDistributionBar,
} from "./components/insight-stat-cards";
import { FlagInsightsTable } from "./components/flag-insights-table";
import { PageContainer } from "./components/page-container";

export const FeatureFlagInsightsPage = () => {
  useDocumentTitle("Feature Flag Insights");

  const { data: flags, isLoading } = useCMWFeatureFlagsQuery();

  const insights = useMemo(() => buildFlagInsights(flags || []), [flags]);
  const metrics = useMemo(() => buildDashboardMetrics(insights), [insights]);

  return (
    <PageContainer>
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <h1 className="scroll-m-20 text-2xl font-extrabold tracking-tight lg:text-3xl">
            Feature Flag Insights
          </h1>
          <p className="mt-1 max-w-2xl text-sm text-muted-foreground">
            Live, read-only view of every CMW feature flag: what it does and who
            has it enabled — globally, per organization, per group, or per user.
          </p>
        </div>
        <Button variant="outline" asChild>
          <Link to="/feature-flags">Open Flag Manager</Link>
        </Button>
      </div>

      <InsightStatCards metrics={metrics} loading={isLoading} />
      <StatusDistributionBar metrics={metrics} loading={isLoading} />

      <FlagInsightsTable insights={insights} loading={isLoading} />
    </PageContainer>
  );
};
